import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip';
import Button from '@mulesoft/anypoint-components/lib/Button';
import { getPath } from '~/utils/routes';
import styles from './Header.css';

const Header = () => {
  const addScannerPath = getPath('agentScannersAdd');

  return (
    <div
      className={styles.headerBar}
      data-test-id="scan-configurations-section-header"
    >
      <div>
        <h2>Agent Scanners</h2>
        <span className={styles.headerBarTitle}>
          Agent Capacity Used: <strong>150 / 10000</strong> Total Agents
        </span>
        <span>
          <Tooltip
            ariaDescribedByTrigger="test-tooltip-info-capacity"
            content="Future agents import will be blocked once the total capacity is reached. Contact your administrator to increase the capacity."
            position="right"
            testId="info-tooltip-capacity"
          >
            <Icon
              name="info"
              size={20}
              title="Info icon"
              aria-label="Info icon"
            />
          </Tooltip>
        </span>
      </div>
      <div
        className={styles.headerBarActions}
        data-test-id="scan-configurations-section-buttons"
      >
        <Link to={addScannerPath}>
          <Button
            type="button"
            kind="primary"
            data-test-id="add-scanner-button"
          >
            Add scanner
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Header;
